// extracted by mini-css-extract-plugin
export default {"saveIndicatorWrapper":"srL5tvtm5RpWi1BjYT6A"};